module.exports = __webpack_public_path__ + "img/phones-md.97a05ffc.png";